import {
  rejectPayrollItems, savePayrollItems,
  unapprovePayrollItems, lockPayrollPeriod,
  unlockPayrollPeriod,
  loadPayrollClassifications,
  loadCampuses,
  changePayrollApprovalUserFilter,
  loadPayrollCampuses,
  loadPayrollApprovalAdjustmentTime,
  loadPayrollApprovalPendingTime,
  generatePayrollItems,
  savePayableItem,
  showEditPayableItem,
  loadPayrollRejectionReasons,
  approveEligiblePayrollItems
} from './../../../../core/store/payroll-approval/payroll-approval.actions';
import { SelectItem } from 'primeng/api';
import { UserModel } from 'src/app/models/userModel';

import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { loadPayPeriods, changePayPeriod } from 'src/app/core/store/payperiod/payperiod.actions';
import { PayPeriodModel } from 'src/app/models/payPeriodModel';
import { PayrollItemModel, PayrollApprovedTotalsModel, PayableItemModel } from 'src/app/models/payableItem';
import { getTimeFormatted, deepClone, getDateNumberComparison, getShortDateFormatted, formatCurrencyNotZero } from 'src/app/helpers/utils';
import { BaseComponent } from 'src/app/core/abstracts/baseComponent';
import { getUsersList } from 'src/app/core/store/users/users.actions';
import {
  loadPayrollApprovalPeriods, changePayrollApprovalPeriod,
  approvePayrollItems
} from 'src/app/core/store/payroll-approval/payroll-approval.actions';
import { AlertService } from '../../../../shared/services/alert.service';
import { saveTimeOffRequestSuccess, showEditTimeOffRequest } from '../../../../core/store/timeoff/timeoff.actions';
import { TimeOffModel } from '../../../../models/timeoffModel';
import { Actions, ofType } from '@ngrx/effects';
import { take, tap } from 'rxjs';
import { PayrollRejectionReasonModel } from 'src/app/models/payrollRejectionReasonModel';
import { PayrollItemsTableComponent } from '../payroll-items-table/payroll-items-table.component';
import { AppPermission } from 'src/app/models/appEnums';

@Component({
    selector: 'app-payroll-approval',
    templateUrl: './payroll-approval.component.html',
    styleUrls: ['./payroll-approval.component.scss'],
    standalone: false
})
export class PayrollApprovalComponent extends BaseComponent implements OnInit {

  @ViewChildren('pendingPayrollTable') pendingPayrollTables: QueryList<PayrollItemsTableComponent>;

  payPeriods: PayPeriodModel[];
  selectedPeriodID: number;

  approvedPayrollItems: PayrollItemModel[] = null;
  invalidPayrollItems: PayrollItemModel[] = null;
  adjustmentPayrollItems: PayrollItemModel[] = null;
  employeeRespondedPayrollItems: PayrollItemModel[] = null;
  pendingPayrollItems: PayrollItemModel[] = null;
  approvedTotals: PayrollApprovedTotalsModel;

  differentPendingPayableTypes: { payableType: string, payrollItems: PayrollItemModel[] }[];
  differentApprovedPayableTypes: { payableType: string, payrollItems: PayrollItemModel[] }[];

  approvedOpened = true;
  invalidOpened = true;
  adjustmentsOpened = true;
  employeeRespondedOpened = true;
  pendingOpened = true;
  approvingPayroll: boolean = false;

  usersList: SelectItem[];
  userID: number;

  pendingPayrollItemsSelected: PayrollItemModel[] = [];
  displayRejectItems: boolean;
  selectedItemsToReject: PayrollItemModel[] = [];

  approvedPayrollItemsSelected: PayrollItemModel[] = [];

  adjustmentsPayrollItemsSelected: PayrollItemModel[] = [];
  employeeRespondedPayrollItemsSelected: PayrollItemModel[] = [];
  displayAdjustmentsItems: boolean;
  editingEmployeeRespondedItems = false;

  rejectDialogTitle = 'Reject Items';
  rejectActionLabel = 'Reject';


  invalidPayrollItemsSelected: PayrollItemModel[] = [];
  displayInvalidItems: boolean;

  isLocked = false;

  payrollClassificationID = 0;
  campusID = 0;

  campusesList: SelectItem[];
  payrollClassificationList: SelectItem[];
  payrollRejectionReasons: PayrollRejectionReasonModel[];
  pendingFilter = 'all';
  displayedPendingPayableTypes: { payableType: string, payrollItems: PayrollItemModel[] }[] = [];
  pendingFilterOptions: SelectItem[] = [
    { label: 'All pending', value: 'all' },
    { label: 'Ready to approve', value: 'eligible' },
    { label: 'Needs review', value: 'flagged' }
  ];
  selectedPendingFlagCode: string;
  pendingFlagOptions: SelectItem[] = [];

  users = {};

  canEdit: boolean;
  showAllPending: boolean = false;
  canViewAllPending: boolean;
  canEditItems: boolean;

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private alertService: AlertService ) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canEdit = permissionIDs && permissionIDs.includes(AppPermission.PayrollApprovalApprove);
        this.canViewAllPending = permissionIDs && permissionIDs.includes(AppPermission.PayrollApprovalShowAllItems);
        this.canEditItems = permissionIDs && permissionIDs.includes(AppPermission.PayrollApprovalEditItems);
      }),
      this.store.select(s => s.payrollApprovalState.isLocked).subscribe(isLocked => {
        this.isLocked = isLocked;
      }),
      this.store.select(s => s.payrollApprovalState.periods).subscribe(periods => {
        this.payPeriods = periods;
      }),
      this.store.select(s => s.payrollApprovalState.selectedPeriodID).subscribe(selectedPeriodID => {
        this.selectedPeriodID = selectedPeriodID;
      }),
      this.store.select(s => s.payrollApprovalState.approvedPayrollItems).subscribe(approvedPayrollItems => {
        this.approvedPayrollItems = approvedPayrollItems;
        this.approvedPayrollItemsSelected = [];
        this.differentApprovedPayableTypes = null;
        if (approvedPayrollItems) {
          this.differentApprovedPayableTypes = approvedPayrollItems
            .filter((p, i) => approvedPayrollItems.findIndex(pi => pi.payableItem.payableType === p.payableItem.payableType) === i)
            .map(p => ({
              payableType: p.payableItem.payableType,
              payrollItems: approvedPayrollItems.filter(pf => pf.payableItem.payableType === p.payableItem.payableType)
            }));
        }
      }),
      this.store.select(s => s.payrollApprovalState.invalidPayrollItems).subscribe(invalidPayrollItems => {
        this.invalidPayrollItems = invalidPayrollItems;
        this.invalidPayrollItemsSelected = [];
      }),
      this.store.select(s => s.payrollApprovalState.adjustmentPayrollItems).subscribe(adjustmentPayrollItems => {
        this.adjustmentsPayrollItemsSelected = [];
        this.employeeRespondedPayrollItemsSelected = [];
        if (adjustmentPayrollItems) {
          this.employeeRespondedPayrollItems = adjustmentPayrollItems
            .filter(item => !!item.payableItem.response && item.payableItem.response.trim().length > 0);
          this.adjustmentPayrollItems = adjustmentPayrollItems
            .filter(item => !item.payableItem.response || item.payableItem.response.trim().length === 0);
        } else {
          this.employeeRespondedPayrollItems = null;
          this.adjustmentPayrollItems = null;
        }
      }),
      this.store.select(s => s.payrollApprovalState.pendingPayrollItems).subscribe(pendingPayrollItems => {
        this.pendingPayrollItems = pendingPayrollItems;
        this.pendingPayrollItemsSelected = [];
        this.differentPendingPayableTypes = null;
        this.displayedPendingPayableTypes = [];
        this.pendingFlagOptions = [];
        this.selectedPendingFlagCode = null;
        if (pendingPayrollItems) {
          this.pendingFlagOptions = pendingPayrollItems
            .reduce((codes, item) => codes.concat((item.flags || []).map(flag => flag.code)), [] as string[])
            .filter((code, index, codes) => codes.indexOf(code) === index)
            .map(code => ({ label: code.replace(/-/g, ' ').replace(/^./, letter => letter.toUpperCase()), value: code }));
          this.differentPendingPayableTypes = pendingPayrollItems
            .filter((p, i) => pendingPayrollItems.findIndex(pi => pi.payableItem.payableType === p.payableItem.payableType) === i)
            .map(p => ({
              payableType: p.payableItem.payableType,
              payrollItems: pendingPayrollItems.filter(pf => pf.payableItem.payableType === p.payableItem.payableType)
            }));
          this.updateDisplayedPendingPayableTypes();
        }
      }),
      this.store.select(s => s.payrollApprovalState.approvedTotals).subscribe(approvedTotals => {
        this.approvedTotals = approvedTotals;
      }),
      this.store.select(s => s.payrollApprovalState.filteredUsers).subscribe(usersList => {
        this.users = usersList.reduce((acc, cur, i) => { acc[cur.id] = cur; return acc; }, {});
        this.usersList = usersList && usersList.length > 0 ? usersList.map(u => ({ label: u.firstName + ' ' + u.lastName, value: u.id }))
          : [{ label: 'loading...', value: undefined }];
      }),
      this.store.select(s => s.payrollApprovalState.payrollCampuses).subscribe(campuses => {
        const campusesList = campuses && campuses.length > 0 ? campuses.map(c => ({ label: c.programName, value: c.id }))
          : [{ label: 'loading...', value: undefined }];
        if (campusesList.length === 1) {
          this.campusID = campusesList[0].value;
          this.changedUserFilters();
        } else {
          campusesList.unshift({ label: 'All', value: 0 });
        }

        this.campusesList = campusesList;

      }),
      this.store.select(s => s.payrollApprovalState.payrollClassifications).subscribe(payrollClassifications => {
        const payrollClassificationList = payrollClassifications && payrollClassifications.length > 0
          ? payrollClassifications.map(p => ({ label: p.payrollClassification, value: p.id }))
          : [{ label: 'loading...', value: undefined }];
        if (payrollClassificationList.length === 1) {
          this.payrollClassificationID = payrollClassificationList[0].value;
          this.changedUserFilters();
        } else {
          payrollClassificationList.unshift({ label: 'All', value: 0 });
        }

        this.payrollClassificationList = payrollClassificationList;
      }),
      this.store.select(s => s.payrollApprovalState.approvingPayroll).subscribe(approving => {
        this.approvingPayroll = approving;
      }),
      this.store.select(s => s.payrollApprovalState.payrollRejectionReasons).subscribe(reasons => {
        this.payrollRejectionReasons = reasons;
      }),

      this.actions$.pipe(
        ofType(saveTimeOffRequestSuccess),
        tap(() => {
          this._refresh();
        })
      ).subscribe(),
    );

    this.store.dispatch(changePayrollApprovalUserFilter({ campusID: 0, payrollClassificationID: 0 }));
    this.store.dispatch(loadPayrollClassifications());
    this.store.dispatch(loadPayrollCampuses());
    this.store.dispatch(loadPayrollRejectionReasons());
    this.store.dispatch(loadPayrollApprovalPeriods());
  }

  refreshPendingAndAdjusmentTime() {
    if (this.userID == null || this.userID == 0) {
      return;
    }

    this.store.dispatch(loadPayrollApprovalAdjustmentTime({ periodID: this.selectedPeriodID, userID: this.userID, showAll: this.showAllPending }));
    this.store.dispatch(loadPayrollApprovalPendingTime({ periodID: this.selectedPeriodID, userID: this.userID, showAll: this.showAllPending }));
  }

  changePeriod(periodID: number) {
    this.store.dispatch(changePayrollApprovalPeriod(
      {
        periodID,
        userID: this.userID,
        showAll: this.showAllPending
      }));
  }

  getTimeFormatted(time) {
    return getTimeFormatted(time);
  }

  getShortDateFormatted(date) {
    return getShortDateFormatted(date);
  }

  formatCurrencyNotZero(bonusPaid) {
    return formatCurrencyNotZero(bonusPaid);
  }

  changedUser() {
    this.store.dispatch(changePayrollApprovalPeriod(
      {
        periodID: this.selectedPeriodID,
        userID: this.userID,
        showAll: this.showAllPending
      }));
  }
  changedUserFilters() {
    this.store.dispatch(changePayrollApprovalUserFilter(
      {
        campusID: this.campusID,
        payrollClassificationID: this.payrollClassificationID
      }));
  }

  // ### Pending
  pendingPayrollItemsSelectedChanged(pendingPayrollItemsSelected: PayrollItemModel[], payableType: string) {
    const newSelected = this.pendingPayrollItemsSelected.filter(p => p.payableItem.payableType !== payableType);
    newSelected.push(...pendingPayrollItemsSelected);
    this.pendingPayrollItemsSelected = newSelected;
  }

  updateDisplayedPendingPayableTypes() {
    this.pendingPayrollItemsSelected = [];
    this.displayedPendingPayableTypes = (this.differentPendingPayableTypes || [])
      .map(group => ({
        payableType: group.payableType,
        payrollItems: group.payrollItems.filter(item => this.pendingFilter === 'all'
          || (this.pendingFilter === 'eligible' && item.autoApprovalEligible)
          || (this.pendingFilter === 'flagged' && !item.autoApprovalEligible))
      }))
      .filter(group => group.payrollItems.length > 0);
  }

  selectPendingItemsByFlag() {
    if (!this.selectedPendingFlagCode) {
      return;
    }
    this.pendingPayrollTables.forEach(table => table.selectItemsByFlag(this.selectedPendingFlagCode));
  }

  approveEligibleTimes() {
    const userID = this.userID;
    const payPeriodID = this.selectedPeriodID;
    const eligibleCount = (this.pendingPayrollItems || []).filter(item => item.autoApprovalEligible).length;
    if (eligibleCount === 0) {
      this.alertService.info('There are no eligible payroll items to approve.');
      return;
    }

    this.alertService.confirm('Approve eligible items',
      `Approve ${eligibleCount} unflagged item(s) at the normal rate? Flagged items will remain pending.`)
      .pipe(take(1))
      .subscribe(answer => {
        if (!answer) {
          return;
        }
        if (this.userID !== userID || this.selectedPeriodID !== payPeriodID) {
          this.alertService.info('The employee or pay period changed. Review the selected payroll and confirm approval again.');
          return;
        }
        if (this.approvingPayroll) {
          this.showAlreadySavingError();
          return;
        }
        this.store.dispatch(approveEligiblePayrollItems({ userID, payPeriodID }));
      });
  }

  approveTimes(approvalType: string, source: 'pending' | 'employeeResponded' = 'pending') {
    const userID = this.userID;
    const payPeriodID = this.selectedPeriodID;
    const selectedPayrollItems = source === 'employeeResponded'
      ? this.employeeRespondedPayrollItemsSelected
      : this.pendingPayrollItemsSelected;
    const payrollItems: PayrollItemModel[] = deepClone(selectedPayrollItems);
    let payPeriod = this.payPeriods.find(x => x.payPeriodID == payPeriodID);
    let itemOutsidePayPeriod = false;
    let itemInGraveyard = payrollItems.some(x => x.isGraveyarded);
    let flaggedItems = payrollItems.some(x => x.flags && x.flags.length > 0);
    if (typeof payPeriod !== 'undefined') {
      let dates = payPeriod.payPeriod.split(' - ');      
      if (dates.length == 2) {
        let startDate = getDateNumberComparison(new Date(dates[0]));
        let endDate = getDateNumberComparison(new Date(dates[1]));        
        itemOutsidePayPeriod = payrollItems.some(x => getDateNumberComparison(x.payableItem.date) - startDate < 0 || endDate - getDateNumberComparison(x.payableItem.date) < 0);
      }
    }
    
    if (itemOutsidePayPeriod || itemInGraveyard || flaggedItems) {
      const concerns = [];
      if (itemOutsidePayPeriod) {
        concerns.push('outside the selected pay period');
      }
      if (itemInGraveyard) {
        concerns.push('in the graveyard');
      }
      if (flaggedItems) {
        concerns.push('flagged for payroll review');
      }
      let message = `You are forcing approval at the selected rate for item(s) ${concerns.join(', ')}.`;
      this.alertService.confirm('WARNING',
        message + ' Are you sure you want to approve all of these items?')
        .pipe(take(1))
        .subscribe(
          answer => {
            if (answer) {
              const currentSelectedPayrollItems = source === 'employeeResponded'
                ? this.employeeRespondedPayrollItemsSelected
                : this.pendingPayrollItemsSelected;
              if (this.userID !== userID || this.selectedPeriodID !== payPeriodID
                || JSON.stringify(currentSelectedPayrollItems) !== JSON.stringify(payrollItems)) {
                this.alertService.info('The employee, pay period, or selected payroll items changed. Review the selection and confirm approval again.');
                return;
              }
              if (this.approvingPayroll) {
                this.showAlreadySavingError();
                return;
              }              
              this.store.dispatch(approvePayrollItems(
                { payrollItems, userID, payPeriodID, approvalType }));
            }
          }, error => {
          }
        );
    }
    else {
      if (this.approvingPayroll) {
        this.showAlreadySavingError();
        return;
      }
      this.store.dispatch(approvePayrollItems(
        { payrollItems, userID, payPeriodID, approvalType }));
    }
  }

  showAlreadySavingError() {
    this.alertService.error("Changes are still saving. Please try again once the data reloads.");
  }

  openRejectTimes(source: 'pending' | 'employeeResponded' = 'pending') {
    this.displayRejectItems = true;
    this.rejectDialogTitle = source === 'employeeResponded' ? 'Request More Changes' : 'Reject Items';
    this.rejectActionLabel = source === 'employeeResponded' ? 'Request More Changes' : 'Reject';
    this.selectedItemsToReject = deepClone(source === 'employeeResponded'
      ? this.employeeRespondedPayrollItemsSelected
      : this.pendingPayrollItemsSelected);
    this.selectedItemsToReject.forEach(item => {
      if (source === 'employeeResponded') {
        item.payableItem.response = '';
      }
      if (!item.payableItem.reason && item.flags?.length) {
        item.payableItem.reason = item.flags.map(flag => flag.reason).join(' ');
      }
    });
  }

  itemsToRejectChanged(items: PayrollItemModel[]) {
    this.selectedItemsToReject = items;
  }

  executeRejectTimes() {
    this.store.dispatch(rejectPayrollItems(
      { payrollItems: this.selectedItemsToReject, userID: this.userID, payPeriodID: this.selectedPeriodID }));
    this.displayRejectItems = false;
  }

  canRejectSelectedItems() {
    return this.selectedItemsToReject && this.selectedItemsToReject.length > 0
      && this.selectedItemsToReject.every(item => !!item.payableItem.reason && item.payableItem.reason.trim().length > 0);
  }

  employeeRespondedPayrollItemsSelectedChanged(payrollItemsSelected: PayrollItemModel[]) {
    this.employeeRespondedPayrollItemsSelected = payrollItemsSelected;
  }

  // ### Approved
  approvedPayrollItemsSelectedChanged(approvedPayrollItemsSelected: PayrollItemModel[], payableType: string) {
    const newSelected = this.approvedPayrollItemsSelected.filter(p => p.payableItem.payableType !== payableType);
    newSelected.push(...approvedPayrollItemsSelected);
    this.approvedPayrollItemsSelected = newSelected;
  }
  executeUnapproveTimes() {
    this.store.dispatch(unapprovePayrollItems(
      { payrollItems: this.approvedPayrollItemsSelected, userID: this.userID, payPeriodID: this.selectedPeriodID }));
  }

  generatePayableItems() {
    if (this.approvingPayroll) {
      this.showAlreadySavingError();
      return;
    }

    this.store.dispatch(generatePayrollItems(
      { userID: this.userID, payPeriodID: this.selectedPeriodID }));
  }

  lockPayperiod() {
    if (this.approvingPayroll) {
      this.showAlreadySavingError();
      return;
    }

    if (this.approvedTotals && this.approvedTotals.matchContractHours) {
      if (this.approvedTotals.totalTime < this.approvedTotals.contractMinutes) {
        this.alertService.error("Employee has not met their contracted hours. Please generate the necessary payable items.");
        return;
      }

      if (this.approvedTotals.totalTime > this.approvedTotals.contractMinutes) {
        this.alertService.error("Employee has exceeded their contract hours. Please unapprove payable items until the approved time does not exceed the contracted hours.");
        return;
      }
    }

    let itemInGraveyard = this.approvedPayrollItems.some(x => x.isGraveyarded); 

    if (itemInGraveyard) {      
      this.alertService.confirm('WARNING',
        '1 or more items of the approved items are in the graveyard. Are you sure you want to approve all of these items?')
        .subscribe(
          answer => {
            if (answer) {
              if (this.approvingPayroll) {
                this.showAlreadySavingError();
                return;
              }
              this.store.dispatch(lockPayrollPeriod(
                { userID: this.userID, payPeriodID: this.selectedPeriodID }));
            }
          }, error => {
          }
        );
    }
    else {
      if (this.approvingPayroll) {
        this.showAlreadySavingError();
        return;
      }
      this.store.dispatch(lockPayrollPeriod(
        { userID: this.userID, payPeriodID: this.selectedPeriodID }));
    }

    
  }

  unlockPayperiod() {
    if (this.approvingPayroll) {
      this.showAlreadySavingError();
      return;
    }

    this.store.dispatch(unlockPayrollPeriod(
      { userID: this.userID, payPeriodID: this.selectedPeriodID }));
  }

  // ### Adjustment
  adjustmentsPayrollItemsSelectedChanged(payrollItemsSelected: PayrollItemModel[]) {
    this.adjustmentsPayrollItemsSelected = payrollItemsSelected;
  }

  adjustmentsPayrollItemsEditClicked(payrollItemsSelected: PayrollItemModel[]) {
    this.adjustmentsPayrollItemsSelected = payrollItemsSelected;
    this.editingEmployeeRespondedItems = false;
    this.displayAdjustmentsItems = true;
  }

  openChangeAdjustmentsTimes() {
    this.editingEmployeeRespondedItems = false;
    this.displayAdjustmentsItems = true;
  }

  employeeRespondedPayrollItemsEditClicked(payrollItemsSelected: PayrollItemModel[]) {
    this.adjustmentsPayrollItemsSelected = payrollItemsSelected;
    this.editingEmployeeRespondedItems = true;
    this.displayAdjustmentsItems = true;
  }

  openEmployeeRespondedItems() {
    this.adjustmentsPayrollItemsSelected = this.employeeRespondedPayrollItemsSelected;
    this.editingEmployeeRespondedItems = true;
    this.displayAdjustmentsItems = true;
  }

  adjustmentsItemsEditingChanged(items: PayrollItemModel[]) {
    this.adjustmentsPayrollItemsSelected = items;
  }

  saveAdjustmentTimes() {
    this.store.dispatch(savePayrollItems(
      { payrollItems: this.adjustmentsPayrollItemsSelected, userID: this.userID, payPeriodID: this.selectedPeriodID }));
    this.displayAdjustmentsItems = false;
  }

  requestMoreChangesFromAdjustment() {
    const payrollItems = deepClone(this.adjustmentsPayrollItemsSelected);
    payrollItems.forEach(item => item.payableItem.response = '');
    this.store.dispatch(rejectPayrollItems(
      { payrollItems, userID: this.userID, payPeriodID: this.selectedPeriodID }));
    this.displayAdjustmentsItems = false;
  }

  canRequestMoreChangesFromAdjustment() {
    return this.adjustmentsPayrollItemsSelected && this.adjustmentsPayrollItemsSelected.length > 0
      && this.adjustmentsPayrollItemsSelected.every(item => !!item.payableItem.reason && item.payableItem.reason.trim().length > 0);
  }

  // ### Invalid
  invalidPayrollItemsSelectedChanged(items: PayrollItemModel[]) {
    this.invalidPayrollItemsSelected = items;
  }

  invalidPayrollItemsEditClicked(items: PayrollItemModel[]) {
    this.invalidPayrollItemsSelected = items;
    this.displayInvalidItems = true;
  }

  openChangeInvalidTimes() {
    this.displayInvalidItems = true;
  }

  invalidItemsEditingChanged(items: PayrollItemModel[]) {
    this.invalidPayrollItemsSelected = items;
  }

  saveInvalidTimes() {
    this.store.dispatch(savePayrollItems(
      { payrollItems: this.invalidPayrollItemsSelected, userID: this.userID, payPeriodID: this.selectedPeriodID }));
    this.displayInvalidItems = false;
  }

  editPayableItemTime(item: PayrollItemModel) {
    this.store.dispatch(showEditPayableItem({ payableItem: item.payableItem }));
  }

  newTimeOffRequest() {
    let user = this.usersList.find(x => x.value === this.userID);
    if (typeof user === 'undefined') {
      this.alertService.error("Please select a user.");
    }
    else {
      let date = new Date();
      let payPeriod = this.payPeriods.find(x => x.payPeriodID == this.selectedPeriodID);
      if (typeof payPeriod !== 'undefined') {
        date = new Date(payPeriod.payPeriod.split('- ')[1]);
      }

      const suggestedPtoMinutes = Math.floor(this.approvedTotals?.suggestedPtoMinutes || 0);
      let model: TimeOffModel = {
        timeOffId: 0,
        userId: user.value,
        patientId: 0,
        startDate: date,
        endDate: date,
        startTime: date,
        endTime: date,
        dateSubmitted: null,
        lastModified: null,
        allDay: true,
        approved: false,
        denied: false,
        comments: null,
        approverComments: null,
        employeeName: user.label,
        patientName: null,
        isPatientTimeOff: false,
        usePto: true,

        startTimeString: null,
        endTimeString: null,
        startDateString: null,
        endDateString: null,

        ptoHours: Math.floor(suggestedPtoMinutes / 60),
        ptoMinutes: suggestedPtoMinutes % 60,
        ptoMinutesUsed: suggestedPtoMinutes,

        isPayroll: true,
        addedByPayroll: true,
        canEditRequest: true,
        canDeleteRequest: true,
        recentChangesMade: "",
      };      
      this.editPtoItem(model);
    }
  }

  editPtoItem(item: TimeOffModel) {
    item.isPayroll = true;
    this.store.dispatch(showEditTimeOffRequest({timeOffRequest: item}));
  }

  _refresh() {
    this.store.dispatch(changePayrollApprovalPeriod(
      {
        periodID: this.selectedPeriodID,
        userID: this.userID,
        showAll: this.showAllPending
      }));
  }

}
